import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
    gap: theme.spacing(2),
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  spinner: {
    marginLeft: theme.spacing(1),
  },
  mono: {
    fontFamily: 'monospace',
  },
  summary: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  error: {
    color: theme.palette.error.main,
    marginBottom: theme.spacing(1),
  },
  warn: {
    color: theme.palette.warning.main,
    marginBottom: theme.spacing(1),
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  tableScroll: {
    marginTop: theme.spacing(1),
    overflowX: 'auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
  },
  table: {
    width: '100%',
    minWidth: 900,
  },
  headRow: {
    background: theme.palette.grey[100],
    '& th': {
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: 0.4,
      textTransform: 'uppercase',
      color: theme.palette.text.secondary,
    },
  },
  narrow: {
    width: 44,
  },
  plate: {
    fontWeight: 700,
    letterSpacing: 0.5,
  },
  muted: {
    color: theme.palette.text.secondary,
  },
  quoteRow: {
    '& > *': { borderBottom: 'unset' },
    '&:hover': { background: theme.palette.action.hover },
  },
  collapseCell: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  detail: {
    margin: theme.spacing(1, 0, 2),
    background: theme.palette.action.hover,
    borderRadius: 4,
    padding: theme.spacing(1, 2),
  },
  plans: {
    margin: 0,
    paddingLeft: theme.spacing(2),
  },
}));
